<mat-card>
  <h2 translate>{{ isUpdate ? 'updateProfile.subtitle' : 'userProfiles.subtitle' }}</h2>
  <p translate *ngIf="!isUpdate">userProfiles.description</p>
  <mat-card-content>
    <ng-container>
      <form [formGroup]="createProfileForm">
        <div>
          <div fxFlex fxLayout="row wrap" class="form-wrapper">
            <!-- ROW -->
            <div fxFlex="60" fxFlex.gt-sm="40">
              <mat-form-field fxFlex="100" appearance="outline">
                <mat-label translate>userProfiles.name</mat-label>
                <input id="name" #name formControlName="name" matInput type="text" autocomplete="off" />
              </mat-form-field>
            </div>
            <div fxFlex="40" fxFlex.gt-sm="25">
              <scf-custom-select-search
                fxFlex="100"
                formControlName="type"
                [id]="'type'"
                [dataInput]="typeList"
                [placeholder]="'userProfiles.type'"
                [isRequired]="true"
                [showErrors]="createProfileForm?.controls?.type?.errors"
              ></scf-custom-select-search>
            </div>
          </div>
        </div>
        <div class="table__wrapper">
          <table aria-label="users" mat-table [dataSource]="this.dataSource.data">
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef class="options-headers" translate>userProfiles.options</th>
              <td mat-cell *matCellDef="let element">{{ element.name }}</td>
            </ng-container>
            <ng-container matColumnDef="NO">
              <th mat-header-cell *matHeaderCellDef class="headers" translate>userProfiles.NO</th>
              <td mat-cell *matCellDef="let row" class="center">
                <mat-radio-button
                  name="{{ 'options' + row.id }}"
                  id="{{ 'checkboxNO' + row.id }}"
                  (click)="$event ? selectHandler(row, 'NO') : null"
                  [checked]="isUpdate ? row.status == 'N' : selectionChecked(true)"
                >
                </mat-radio-button>
              </td>
            </ng-container>
            <ng-container matColumnDef="YES">
              <th mat-header-cell *matHeaderCellDef class="headers" translate>userProfiles.YES</th>
              <td mat-cell *matCellDef="let row" class="center">
                <mat-radio-button
                  name="{{ 'options' + row.id }}"
                  id="{{ 'checkboxYES' + row.id }}"
                  (click)="$event ? selectHandler(row, 'YES') : null"
                  [checked]="isUpdate ? isCheckedYES(row) : false"
                >
                </mat-radio-button>
              </td>
            </ng-container>
            <ng-container matColumnDef="OPC">
              <th mat-header-cell *matHeaderCellDef class="headers" translate>userProfiles.OPC</th>
              <td mat-cell *matCellDef="let row" class="center">
                <mat-radio-button
                  name="{{ 'options' + row.id }}"
                  id="{{ 'checkboxOPC' + row.id }}"
                  (click)="$event ? selectHandler(row, 'OPC') : null"
                  [checked]="isUpdate ? isCheckedOPT(row) : false"
                >
                </mat-radio-button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
        </div>
      </form>
    </ng-container>
  </mat-card-content>
</mat-card>

<div class="actions">
  <button
    id="updateBtn"
    mat-flat-button
    color="accent"
    type="submit"
    class="form__btn-submit"
    [disabled]="!createProfileForm.valid"
    (click)="saveUpdateProfile(isUpdate)"
  >
    <mat-label translate *ngIf="!isUpdate">userProfiles.button</mat-label>
    <mat-label translate *ngIf="isUpdate">Modificar perfil</mat-label>
  </button>
</div>
